import { render, staticRenderFns } from "./WorksEditPanelDialog.vue?vue&type=template&id=7766885a"
import script from "./WorksEditPanelDialog.vue?vue&type=script&lang=js"
export * from "./WorksEditPanelDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports